import { render, staticRenderFns } from "./BackupRecovery.vue?vue&type=template&id=69536edc&scoped=true"
import script from "./BackupRecovery.vue?vue&type=script&lang=js"
export * from "./BackupRecovery.vue?vue&type=script&lang=js"
import style0 from "./BackupRecovery.vue?vue&type=style&index=0&id=69536edc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69536edc",
  null
  
)

export default component.exports